export default {
    'memberAreaPointsHistory.title': '活動集點',
    'memberAreaPointsHistory.point_detail': '點數明細',
    'memberAreaPointsHistory.event_name': '活動名稱',
    'memberAreaPointsHistory.placeholder.event': '請輸入活動名稱',
} as Record<string, string>;
